export default "__VITE_ASSET__fUKCdcBK__"